export interface PaymentStatus {
  use_deposit_payments: boolean;
  deposit_paid: boolean;
}

export function requiresDeposit(paymentStatus: PaymentStatus): boolean {
  return paymentStatus.use_deposit_payments && !paymentStatus.deposit_paid;
}
